import { getCurrentScope, onScopeDispose, readonly, ref, type Ref } from 'vue'

/** Tracks whether the tab is hidden, updating when the founder switches tabs or windows. */
export function useDocumentHidden(): Readonly<Ref<boolean>> {
  if (typeof document === 'undefined') return readonly(ref(false))
  const hidden = ref(document.hidden)

  const update = (): void => {
    hidden.value = document.hidden
  }
  document.addEventListener('visibilitychange', update)
  if (getCurrentScope())
    onScopeDispose(() => document.removeEventListener('visibilitychange', update))
  return readonly(hidden)
}
